<template>
  <analytics-sub-page
    title="Savings Analytics"
    icon="piggy-bank"
    css-class="analytics-savings"
    default-label="Savings"
    :section-specs="sectionSpecs"
  >
    <build-metrics ref="buildRef" />
  </analytics-sub-page>
</template>

<script setup>
import { ref } from 'vue';
import AnalyticsSubPage from '@/components/AnalyticsSubPage.vue';
import BuildMetrics, { buildMetricsSections } from '@/pages/analyticsApp/components/BuildMetrics.vue';

const buildRef = ref(null);

// BuildMetrics carves itself into several logical subsections (Savers /
// Deposits / Interest / External deposits / Balances / Prizes). The section
// descriptors live with the component so this tab and the homepage "Download
// all" capture stay in sync.
const sectionSpecs = buildMetricsSections(buildRef);
</script>
